import * as bitcoin from 'bitcoinjs-lib';
import decimal from 'decimal.js';
import { words } from './globalState';
import {
  getAddressFromKey,
  getValidKeyPairs,
  setSignatureByAddressMain,
  signWithKey,
  getKeyPairsFromMnemonic,
  handleClickNfc,
  generateMnemonic,
} from './keysAndSigning';
import {
  broadcastMonaTransactions,
  broadcastTransaction,
  buildMonapartyTransactions,
  getTransaction,
  getUtxo,
  selectUtxoMona,
  selectUtxoWatanabe,
  getRawTransaction,
  getAddressInfo,
  getAssetInfo,
  getBalancesMonaparty,
  getFeeRate,
  getMonacard,
  getOwnedAssets,
  getRegisteredCard,
  calculateChangeWatanabe,
  buildUnsignedTransactionSendMona,
  signTransaction,
} from './blockchain';
import { encrypt } from './crypto';
import {
  decimalAdjust,
  devLog,
  sleep,
  syncHttpRequest,
  syncHttpRequest2,
  syncHttpRequestOrThrow,
  writeOnNfc,
} from './utils';

let wallet;

// トークン数量（表示用）
function quantityForDisplay(state, item, quantity) {
  let quantityRaw;
  let quantityForDisplay;

  if (quantity !== undefined && quantity !== null) {
    quantityRaw = quantity;
  }
  else {
    quantityRaw = item.quantity;
  }

  if (state.assetInfo[item.asset]?.divisible === true) {
    quantityForDisplay = new decimal(quantityRaw).div(100000000).toNumber();
  }
  else if (item.divisible === true) {
    quantityForDisplay = new decimal(quantityRaw).div(100000000).toNumber();
  }
  else {
    quantityForDisplay = quantityRaw;
  }

  return quantityForDisplay;
}

// MONAをカゴに入れる
// ADD SENDS TO THE CART MONA
function addSendsToTheCartMona(state, dispatch, addressFrom, addressTo, quantity) {
  const actionItemsMultiSources = state.cartMona;
  let done;

  if (actionItemsMultiSources[addressFrom] === undefined) {
    actionItemsMultiSources[addressFrom] = [];
  }

  for (const actionItem of actionItemsMultiSources[addressFrom]) {
    if (actionItem.action === 'send') {
      actionItem.recipients.push(
        {
          addressTo: addressTo,
          amountWatanabe: quantity,
        },
      );

      done = true;
      break;
    }
  }

  if (!done) {
    actionItemsMultiSources[addressFrom].push(
      {
        transactionType: 'sendMona',
        action: 'send',
        status: 'unprocessed',
        addressFrom: addressFrom,
        recipients: [
          {
            addressTo: addressTo,
            amountWatanabe: quantity,
          },
        ],
      },
    );
  }

  dispatch({ type: 'setState', key: 'cartMona', value: actionItemsMultiSources });

  return actionItemsMultiSources;
}

// モナパトークンをカゴに入れる
// ADD TOKENS TO THE CART MONAPARTY
function addTokensToTheCartMonaparty(state, dispatch, addressFrom, addressTo, asset, quantity) {
  const actionItemsMultiSources = state.cartMonaparty;
  let done;

  if (actionItemsMultiSources[addressFrom] === undefined) {
    actionItemsMultiSources[addressFrom] = [];
  }

  for (const actionItem of actionItemsMultiSources[addressFrom]) {
    if (actionItem.action === 'send') {
      if (actionItem.recipients[addressTo] === undefined) {
        actionItem.recipients[addressTo] = {};
      }

      if (actionItem.recipients[addressTo][asset] === undefined) {
        actionItem.recipients[addressTo][asset] = { quantity: 0 };
      }

      actionItem.recipients[addressTo][asset].quantity += quantity;

      done = true;
      break;
    }
  }

  if (!done) {
    actionItemsMultiSources[addressFrom].push(
      {
        transactionType: 'sendToken',
        action: 'send',
        status: 'unprocessed',
        addressFrom: addressFrom,
        recipients: {
          [addressTo]: {
            [asset]: {
              quantity: quantity,
            },
          },
        },
      },
    );
  }

  dispatch({ type: 'setState', key: 'cartMonaparty', value: actionItemsMultiSources });

  return actionItemsMultiSources;
}

// モナパトークンを一回カゴを空にしてから入れる
// ADD TOKENS TO THE CART MONAPARTY AFTER EMPTYING
function addTokensToTheCartMonapartyAfterEmptying(state, dispatch, addressFrom, addressTo, asset, quantity) {
  const actionItemsMultiSources = {};
  actionItemsMultiSources[addressFrom] = [];

  actionItemsMultiSources[addressFrom].push(
    {
      transactionType: 'sendToken',
      action: 'send',
      status: 'unprocessed',
      addressFrom: addressFrom,
      recipients: {
        [addressTo]: {
          [asset]: {
            quantity: quantity,
          },
        },
      },
    },
  );

  dispatch({ type: 'setState', key: 'cartMonaparty', value: actionItemsMultiSources });

  return actionItemsMultiSources;
}

// アセット発行をカゴに入れる
// ADD ISSUANCE TO THE CART MONAPARTY
function addIssuanceToTheCartMonaparty(state, dispatch, addressIssuer, assetCommon, quantity, description, divisible, listed, vendable, reassignable, assetType) {
  const actionItemsMultiSources = state.cartMonaparty;

  if (actionItemsMultiSources[addressIssuer] === undefined) {
    actionItemsMultiSources[addressIssuer] = [];
  }

  actionItemsMultiSources[addressIssuer].push(
    {
      transactionType: 'monaparty',
      action: 'issue',
      status: 'unprocessed',
      addressIssuer: addressIssuer,
      assetCommon: assetCommon,
      quantity: quantity,
      description: description,
      divisible: divisible,
      listed: listed,
      vendable: vendable,
      reassignable: reassignable,
      assetType: assetType,
    },
  );

  dispatch({ type: 'setState', key: 'cartMonaparty', value: actionItemsMultiSources });

  return actionItemsMultiSources;
}

// モナカード更新をカゴに入れる
// ADD EDIT MONACARD TO THE CART MONAPARTY
function addEditMonacardToTheCartMonaparty(state, dispatch, editMode, addressOwner, asset, assetCommon, description, divisible, listed, vendable, reassignable) {
  const actionItemsMultiSources = state.cartMonaparty;

  let action;

  if (editMode === 'editMonacard') {
    action = 'editMonacard';
  }
  else if (editMode === 'editAdvancedToken') {
    action = 'editAdvancedToken';
  }

  if (actionItemsMultiSources[addressOwner] === undefined) {
    actionItemsMultiSources[addressOwner] = [];
  }

  actionItemsMultiSources[addressOwner].push(
    {
      transactionType: 'monaparty',
      action: action,   
      status: 'unprocessed',
      addressOwner: addressOwner,
      asset: asset,
      assetCommon: assetCommon,
      quantity: 0,
      description: description,
      divisible: divisible,
      listed: listed,
      vendable: vendable,
      reassignable: reassignable,
    },
  );

  dispatch({ type: 'setState', key: 'cartMonaparty', value: actionItemsMultiSources });

  return actionItemsMultiSources;
}

// 追加アセット発行をカゴに入れる
// ADD ADDITIONAL ISSUANCE TO THE CART MONAPARTY
function addAdditionalIssuanceToTheCartMonaparty(state, dispatch, addressOwner, asset, assetCommon, quantity, description, divisible, listed, vendable, reassignable) {
  const actionItemsMultiSources = state.cartMonaparty;

  if (actionItemsMultiSources[addressOwner] === undefined) {
    actionItemsMultiSources[addressOwner] = [];
  }

  actionItemsMultiSources[addressOwner].push(
    {
      transactionType: 'monaparty',
      action: 'additionalIssuance',
      status: 'unprocessed',
      addressOwner: addressOwner,
      asset: asset,
      assetCommon: assetCommon,
      quantity: quantity,
      description: description,
      divisible: divisible,
      listed: listed,
      vendable: vendable,
      reassignable: reassignable,
    },
  );

  dispatch({ type: 'setState', key: 'cartMonaparty', value: actionItemsMultiSources });

  return actionItemsMultiSources;
}

// 新規発行ロックをカゴに入れる
// ADD LOCK ISSUANCE TO THE CART MONAPARTY
function addLockIssuanceToTheCartMonaparty(state, dispatch, addressOwner, asset, assetCommon, divisible, listed, vendable, reassignable) {
  const actionItemsMultiSources = state.cartMonaparty;

  if (actionItemsMultiSources[addressOwner] === undefined) {
    actionItemsMultiSources[addressOwner] = [];
  }

  actionItemsMultiSources[addressOwner].push(
    {
      transactionType: 'monaparty',
      action: 'lockIssuance',
      status: 'unprocessed',
      addressOwner: addressOwner,
      asset: asset,
      assetCommon: assetCommon,
      quantity: 0,
      description: 'LOCK',
      divisible: divisible,
      listed: listed,
      vendable: vendable,
      reassignable: reassignable,
    },
  );

  dispatch({ type: 'setState', key: 'cartMonaparty', value: actionItemsMultiSources });

  return actionItemsMultiSources;
}

// トークン所有権移転をカゴに入れる
// ADD TRANSFER OWNERSHIP TO THE CART MONAPARTY
function addTransferOwnershipToTheCartMonaparty(state, dispatch, addressOwner, asset, assetCommon, addressNewOwner, description, divisible, listed, vendable, reassignable) {
  const actionItemsMultiSources = state.cartMonaparty;

  if (actionItemsMultiSources[addressOwner] === undefined) {
    actionItemsMultiSources[addressOwner] = [];
  }

  actionItemsMultiSources[addressOwner].push(
    {
      transactionType: 'monaparty',
      action: 'transferOwnership',
      status: 'unprocessed',
      addressOwner: addressOwner,
      asset: asset,
      assetCommon: assetCommon,
      addressNewOwner: addressNewOwner,
      quantity: 0,
      description: description,
      divisible: divisible,
      listed: listed,
      vendable: vendable,
      reassignable: reassignable,
    },
  );

  dispatch({ type: 'setState', key: 'cartMonaparty', value: actionItemsMultiSources });

  return actionItemsMultiSources;
}

// BUILD MONA TRANSACTIONS
async function buildMonaTransactions(state, dispatch, keyPairs, actionItemsMultiSources, { provisionalTransactionFee, transactionFeeUpperBound }) {
  let result;
  let utxos;
  let feeRate;
  let transactionFee;
  let change;
  let virtualSize;
  let transactionUnsignedPreBuild;
  let transactionSignedPreBuild;
  let transactionUnsigned;
  let transactionSigned;

  // const keyPairDummy = bitcoin.ECPair.fromWIF(state.config.clientParameters.wifDummy, networkMona);

  devLog('provisionalTransactionFee', provisionalTransactionFee);

  SOURCE: for (const addressFrom of Object.keys(actionItemsMultiSources)) {
    const keyPair = keyPairs[addressFrom]?.keyPair;

    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressFrom]) {
      // actionItem単位でトランザクションを作成し、ブロードキャストする。

      if (actionItem.status === 'unprocessed') {
        if (actionItem.action === 'send' && actionItem.recipients.length >= 1) {
          const amountWatanabeTotal = actionItem.recipients.reduce((acc, cur) => acc + cur.amountWatanabe, 0);

          // UTXO取得
          result = await getUtxo({ clientParameters: state.config.clientParameters, address: addressFrom });

          if (result.status === 'fulfilled' && result.body.error === undefined) {
            utxos = result.body;
          }
          else {
            const error = result.status !== 'fulfilled' ? result.error : result.body.error;

            devLog(`failed to get UTXO.; ${error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToBuildTransaction[state.language]}; failed to get UTXO.; ${result.error}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToGetUtxos';
            actionItem.error = error;
            // continue ACTION_ITEM;
            break SOURCE;
          }

          // UTXO選定
          utxos.sort( (a, b) => a.satoshis - b.satoshis );
          const utxosSelected = selectUtxoWatanabe(utxos, amountWatanabeTotal + provisionalTransactionFee); // boundaryは概算。provisionalTransactionFeeには少し余裕をもたせるべし。
          devLog('utxosSelected', JSON.stringify(utxosSelected));

          if (utxosSelected === null) {
            devLog('short of MONA');
            dispatch({ type: 'setNotification', key: 'notification', value: words.failedToBuildTransaction[state.language] + '; short of MONA' });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'shortOfMona';
            // continue ACTION_ITEM;
            break SOURCE;
          }

          // UTX raw transaction取得
          result = await getRawTransaction(state, utxosSelected);

          if (result.status === 'rejected') {
            devLog(`failed to get unspent raw transactions.; ${result.error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToBuildTransaction[state.language]} ; failed to get unspent raw transactions.; ${result.error}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToGetUnspentRawTransactions';
            actionItem.error = result.error;
            // continue ACTION_ITEM;
            break SOURCE;
          }

          // fee rate取得
          result = await getFeeRate({ clientParameters: state.config.clientParameters });

          if (result.status === 'fulfilled' && result.body.error === undefined) {
            feeRate = result.body;
          }
          else {
            const error = result.status !== 'fulfilled' ? result.error : result.body.error;

            devLog(`failed to get fee rate.; ${error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToBuildTransaction[state.language]}; failed to get fee rate.; ${error}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToGetFeeRate';
            actionItem.error = error;
            // continue ACTION_ITEM;
            break SOURCE;
          }

          // input, output作成

          const changeOfZeroFee = utxosSelected.reduce((acc, cur) => acc + cur.satoshis, 0) - amountWatanabeTotal;

          const inputs = utxosSelected.map( utxo => {
            return {
              txid: utxo.txid,
              vout: utxo.vout,
              rawTransaction: utxo.rawTransaction,
            };
          });

          devLog('inputs', JSON.stringify(inputs));

          const outputs = actionItem.recipients.map( recipient => {
            return {
              address: recipient.addressTo,
              amount: recipient.amountWatanabe,
            };
          });

          const outputsPreBuild = [ ...outputs ];

          outputsPreBuild.push(
            {
              address: addressFrom,
              amount: changeOfZeroFee,
            }
          );

          devLog('outputsPreBuild', JSON.stringify(outputsPreBuild));


          // 仮トランザクション作成(トランザクションサイズ取得のため)

          result = buildUnsignedTransactionSendMona(state.networkMona, inputs, outputsPreBuild);

          if (result.status === 'fulfilled') {
            transactionUnsignedPreBuild = result.body;
          }
          else {
            devLog(`failed to pre-build transaction.; ${result.error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToBuildTransaction[state.language]}; failed to pre-build transaction.; ${result.error}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToPreBuildTransaction';
            actionItem.error = result.error;
            // continue ACTION_ITEM;
            break SOURCE;
          }

          if (keyPair !== undefined) {
            // 仮トランザクション署名(トランザクションサイズ取得のため)

            result = signTransaction(state.networkMona, transactionUnsignedPreBuild, keyPair);

            if (result.status === 'fulfilled') {
              transactionSignedPreBuild = result.body;
            }
            else {
              devLog(`failed to pre-sign transaction.; ${result.error}`);
              dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToBuildTransaction[state.language]}; failed to pre-sign transaction.; ${result.error}` });

              actionItem.status = 'failed';
              actionItem.statusDetail = 'failedToPreSign';
              actionItem.error = result.error;
              // continue ACTION_ITEM;
              break SOURCE;
            }

            // トランザクションサイズ取得

            virtualSize = bitcoin.Transaction.fromHex(transactionSignedPreBuild).virtualSize();
            console.log('virtualSize', virtualSize);
          }
          else {
            // トランザクションサイズ取得

            virtualSize = bitcoin.Transaction.fromHex(transactionUnsignedPreBuild).virtualSize();
            console.log('approximated virtualSize', virtualSize);
          }

          // 本トランザクション作成

          // お釣り計算

          result = calculateChangeWatanabe(utxosSelected, amountWatanabeTotal, feeRate, virtualSize, transactionFeeUpperBound);

          if (result.status === 'fulfilled') {
            change = result.body.change;
            transactionFee = result.body.transactionFee;
          }
          else {
            devLog(`failed to calculate change.; ${result.error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToBuildTransaction[state.language]}; failed to calculate change.; ${result.error}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToCalculateChange';
            actionItem.error = result.error;
            // continue ACTION_ITEM;
            break SOURCE;
          }

          // トランザクション作成

          outputs.push(
            {
              address: addressFrom,
              amount: change,
            }
          );

          devLog('outputs', JSON.stringify(outputs));

          result = buildUnsignedTransactionSendMona(state.networkMona, inputs, outputs);

          if (result.status === 'fulfilled') {
            transactionUnsigned = result.body;
          }
          else {
            devLog(`failed to build transaction.; ${result.error}`);
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToBuildTransaction[state.language]}; failed to build transaction.; ${result.error}` });

            actionItem.status = 'failed';
            actionItem.statusDetail = 'failedToBuildTransaction';
            actionItem.error = result.error;
            // continue ACTION_ITEM;
            break SOURCE;
          }

          // トランザクション署名

          if (keyPair !== undefined) {
            result = signTransaction(state.networkMona, transactionUnsigned, keyPair);

            if (result.status === 'fulfilled') {
              transactionSigned = result.body;
              actionItem.transactionSigned = transactionSigned;
              actionItem.transactionFee = transactionFee;
              actionItem.status = 'succeeded';
              actionItem.statusDetail = 'signed';
            }
            else {
              devLog(`failed to sign transaction.; ${result.error}`);
              dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSignTransaction[state.language]}; ${result.error}` });

              actionItem.status = 'failed';
              actionItem.statusDetail = 'failedToSignWithKey';
              actionItem.error = result.error;
              // continue ACTION_ITEM;
              break SOURCE;
            }
          }
          else if (window.mpurse) { // Mpurse
            result = await window.mpurse.signRawTransaction(transactionUnsigned)
            .then( async (result) => {
              devLog('succeeded to sign transaction.');
              devLog(result);

              return {
                status: 'fulfilled',
                body: result,
              };
            })
            .catch( (error) => {
              devLog('failed to sign transaction with Mpurse.');
              devLog(error);

              // notification
              dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSignTransaction[state.language]}; ${error}` });

              return {
                status: 'rejected',
                body: error
              };
            });

            if (result.status === 'fulfilled') {
              transactionSigned = result.body;
              actionItem.transactionSigned = transactionSigned;
              actionItem.transactionFee = transactionFee;
              actionItem.status = 'succeeded';
              actionItem.statusDetail = 'signed';
            }
            else {
              actionItem.status = 'failed';
              actionItem.statusDetail = 'failedToSignWithMpurse';
              actionItem.error = result.error;
              // continue ACTION_ITEM;
              break SOURCE;
            }
          }
          else {
            devLog('failed to sign transaction.; no keyPair and no Mpurse.');
            dispatch({ type: 'setNotification', key: 'notification', value: `${words.failedToSignTransaction[state.language]} ${words.pleaseLogin[state.language]}` });
          }
        }
        else { // sendしかない
        }

        break SOURCE;
      }
    }
  }

  return actionItemsMultiSources;
}

// PUSH INTO HISTORY MONA TRANSACTIONS
function pushIntoHistoryMonaTransactions(state, dispatch, actionItemsMultiSources) {

  // 履歴に格納

  const history = state.actionHistory;
  const historyThisTime = [];

  for (const addressFrom of Object.keys(actionItemsMultiSources)) {
    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressFrom]) {
      let actionItemInHistory;

      if (actionItem.transactionType === 'sendMona') {
        actionItemInHistory = {
          transactionType: actionItem.transactionType, // 変わらない
          action: actionItem.action, // 変わらない
          addressFrom: actionItem.addressFrom, // 変わらない
          recipients: actionItem.recipients.map( recipient => {
            return {
              addressTo: recipient.addressTo,
              amountWatanabe: recipient.amountWatanabe,
            };
          }), // 変わる
          status: actionItem.status, // 変わる
          statusDetail: actionItem.statusDetail, // 変わる
          transactionSigned: actionItem.transactionSigned, // 変わる
          txid: actionItem.txid, // 変わる
          transactionFee: actionItem.transactionFee, // 変わる
        };
      }
      else if (actionItem.transactionType === 'sendToken') {
        let recipients = {};

        for (const addressTo of Object.keys(actionItem.recipients)) {
          recipients[addressTo] = {};

          for (const asset of Object.keys(actionItem.recipients[addressTo])) {
            recipients[addressTo][asset] = {
              quantity: actionItem.recipients[addressTo][asset].quantity,
            };
          }
        }

        actionItemInHistory = {
          transactionType: actionItem.transactionType, // 変わらない
          action: actionItem.action, // 変わらない
          addressFrom: actionItem.addressFrom, // 変わらない
          recipients, // 変わる
          status: actionItem.status, // 変わる
          statusDetail: actionItem.statusDetail, // 変わる
          transactionSigned: actionItem.transactionSigned, // 変わる
          txid: actionItem.txid, // 変わる
          transactionFee: actionItem.transactionFee, // 変わる
          outValueExcludeChange: actionItem.outValueExcludeChange, // 変わる
        };
      }
      else if (actionItem.action === 'issue') {
        actionItemInHistory = {
          transactionType: actionItem.transactionType, // 変わらない
          action: actionItem.action, // 変わらない
          addressIssuer: actionItem.addressIssuer, // 変わらない
          assetCommon: actionItem.assetCommon, // 変わらない
          quantity: actionItem.quantity, // 変わらない
          description: actionItem.description, // 変わらない
          // lock: actionItem.lock, // 変わらない
          divisible: actionItem.divisible, // 変わらない
          listed: actionItem.listed, // 変わらない
          vendable: actionItem.vendable, // 変わらない
          reassignable: actionItem.reassignable, // 変わらない
          status: actionItem.status, // 変わる
          statusDetail: actionItem.statusDetail, // 変わる
          transactionSigned: actionItem.transactionSigned, // 変わる
          txid: actionItem.txid, // 変わる
          transactionFee: actionItem.transactionFee, // 変わる
          outValueExcludeChange: actionItem.outValueExcludeChange, // 変わる
          assetType: actionItem.assetType, // 変わらない
        };
      }
      else if (actionItem.action === 'editMonacard' || actionItem.action === 'editAdvancedToken') {
        actionItemInHistory = {
          transactionType: actionItem.transactionType, // 変わらない
          action: actionItem.action, // 変わらない
          addressOwner: actionItem.addressOwner, // 変わらない
          asset: actionItem.asset, // 変わらない
          assetCommon: actionItem.assetCommon, // 変わらない
          quantity: actionItem.quantity, // 変わらない
          description: actionItem.description, // 変わらない
          divisible: actionItem.divisible, // 変わらない
          listed: actionItem.listed, // 変わらない
          vendable: actionItem.vendable, // 変わらない
          reassignable: actionItem.reassignable, // 変わらない
          status: actionItem.status, // 変わる
          statusDetail: actionItem.statusDetail, // 変わる
          transactionSigned: actionItem.transactionSigned, // 変わる
          txid: actionItem.txid, // 変わる
          transactionFee: actionItem.transactionFee, // 変わる
          outValueExcludeChange: actionItem.outValueExcludeChange, // 変わる
        };
      }
      else if (actionItem.action === 'additionalIssuance') {
        actionItemInHistory = {
          transactionType: actionItem.transactionType, // 変わらない
          action: actionItem.action, // 変わらない
          addressOwner: actionItem.addressOwner, // 変わらない
          asset: actionItem.asset, // 変わらない
          assetCommon: actionItem.assetCommon, // 変わらない
          quantity: actionItem.quantity, // 変わらない
          description: actionItem.description, // 変わらない
          divisible: actionItem.divisible, // 変わらない
          listed: actionItem.listed, // 変わらない
          vendable: actionItem.vendable, // 変わらない
          reassignable: actionItem.reassignable, // 変わらない
          status: actionItem.status, // 変わる
          statusDetail: actionItem.statusDetail, // 変わる
          transactionSigned: actionItem.transactionSigned, // 変わる
          txid: actionItem.txid, // 変わる
          transactionFee: actionItem.transactionFee, // 変わる
          outValueExcludeChange: actionItem.outValueExcludeChange, // 変わる
        };
      }
      else if (actionItem.action === 'lockIssuance') {
        actionItemInHistory = {
          transactionType: actionItem.transactionType, // 変わらない
          action: actionItem.action, // 変わらない
          addressOwner: actionItem.addressOwner, // 変わらない
          asset: actionItem.asset, // 変わらない
          assetCommon: actionItem.assetCommon, // 変わらない
          quantity: actionItem.quantity, // 変わらない
          description: actionItem.description, // 変わらない
          divisible: actionItem.divisible, // 変わらない
          listed: actionItem.listed, // 変わらない
          vendable: actionItem.vendable, // 変わらない
          reassignable: actionItem.reassignable, // 変わらない
          status: actionItem.status, // 変わる
          statusDetail: actionItem.statusDetail, // 変わる
          transactionSigned: actionItem.transactionSigned, // 変わる
          txid: actionItem.txid, // 変わる
          transactionFee: actionItem.transactionFee, // 変わる
          outValueExcludeChange: actionItem.outValueExcludeChange, // 変わる
        };
      }
      else if (actionItem.action === 'transferOwnership') {
        actionItemInHistory = {
          transactionType: actionItem.transactionType, // 変わらない
          action: actionItem.action, // 変わらない
          addressOwner: actionItem.addressOwner, // 変わらない
          asset: actionItem.asset, // 変わらない
          assetCommon: actionItem.assetCommon, // 変わらない
          addressNewOwner: actionItem.addressNewOwner, // 変わらない
          quantity: actionItem.quantity, // 変わらない
          divisible: actionItem.divisible, // 変わらない
          listed: actionItem.listed, // 変わらない
          vendable: actionItem.vendable, // 変わらない
          reassignable: actionItem.reassignable, // 変わらない
          status: actionItem.status, // 変わる
          statusDetail: actionItem.statusDetail, // 変わる
          transactionSigned: actionItem.transactionSigned, // 変わる
          txid: actionItem.txid, // 変わる
          transactionFee: actionItem.transactionFee, // 変わる
          outValueExcludeChange: actionItem.outValueExcludeChange, // 変わる
        };
      }

      historyThisTime.unshift(actionItemInHistory);
    }
  }

  history.unshift(...historyThisTime);
  dispatch({ type: 'setState', key: 'actionHistory', value: history });
  devLog('historyThisTime', JSON.stringify(historyThisTime));

  return historyThisTime;
}

// UPDATE CART
function updateCart(state, dispatch, actionItemsMultiSources, cart) {

  // カート更新

  const actionItemsMultiSourcesNew = {};

  for (const addressFrom of Object.keys(actionItemsMultiSources)) {
    const actionItemsNew = actionItemsMultiSources[addressFrom].filter( actionItem => actionItem.status === 'failed' );

    if (actionItemsNew.length >= 1) {
      actionItemsMultiSourcesNew[addressFrom] = actionItemsNew;
    }
  }

  dispatch({ type: 'setState', key: cart, value: actionItemsMultiSourcesNew });

  return actionItemsMultiSourcesNew;
}

// HANDLE CLICK COMMIT MONA TRANSACTION
function handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, network) {
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  devLog('popupLayer popupLayerNext', popupLayer, popupLayerNext);

  const buttonFaceOk =
  <div>
    OK
  </div>;

  const buttonFaceCancel =
  <div>
    CANCEL
  </div>;

  const callbackOk = async () => {
    dispatch({ type: 'setState', key: 'accessing', value: true });

    await broadcastMonaTransactions(state, dispatch, actionItemsMultiSourcesSigned);
    devLog('resultOfBroadcast', JSON.stringify(actionItemsMultiSourcesSigned));

    dispatch({ type: 'setState', key: 'accessing', value: false });

    if (
      Object.keys(actionItemsMultiSourcesSigned).some( source => 
        actionItemsMultiSourcesSigned[source].some( actionItem => actionItem.status === 'unprocessed' )
      )
    ) {
      const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

      dispatch({ type: 'setState', key: 'accessing', value: true });

      if (network === 'mona') {
        await buildMonaTransactions(
          state, dispatch, keyPairs, actionItemsMultiSourcesSigned,
          {
            provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
            transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
          }
        );
      }
      else { // monaparty
        await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSourcesSigned);
      }

      devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

      dispatch({ type: 'setState', key: 'accessing', value: false });

      handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, network);
    }
    else {
      const historyThisTime = await pushIntoHistoryMonaTransactions(state, dispatch, actionItemsMultiSourcesSigned);
      devLog('historyThisTime', JSON.stringify(historyThisTime));

      let cart;

      if (network === 'mona') {
        cart = 'cartMona';
      }
      else { // monaparty
        cart = 'cartMonaparty';
      }

      updateCart(state, dispatch, actionItemsMultiSourcesSigned, cart);

      if (historyThisTime.length === 0) {
        dispatch({ type: 'setNotification', key: 'notification', value: 'no action item.' });
      }
      else if (historyThisTime.every( actionItem => actionItem.status === 'succeeded' )) {
        dispatch({ type: 'setNotification', key: 'notification', value: words.succeededAtLast[state.language] });
      }
      else {
        if (historyThisTime.some( actionItem => actionItem.status === 'succeeded' )) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.succeededPartially[state.language] });
        }
        else {
          dispatch({ type: 'setNotification', key: 'notification', value: words.failedAtLast[state.language] });
        }
      }

      for (let i = 0; i <= popupLayerNext; i++) {
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', i], value: { type: null, body: null } });
      }
    }
  }

  const callbackCancel = async () => {
    const resultOfPushingIntoHistory = await pushIntoHistoryMonaTransactions(state, dispatch, actionItemsMultiSourcesSigned);
    devLog('resultOfPushingIntoHistory', JSON.stringify(resultOfPushingIntoHistory));

    dispatch({ type: 'setNotification', key: 'notification', value: words.canceledRemainingInCart[state.language] });

    for (let i = 0; i <= popupLayerNext; i++) {
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', i], value: { type: null, body: null } });
    }
  }

  const popup = {
    type: 'commitMonaTransactionConfirmationPopup',
    body: {
      actionItemsMultiSourcesSigned,
      buttonFaceOk,
      buttonFaceCancel,
      callbackOk,
      callbackCancel,
    },
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
}

// HANDLE CLICK ISSUE ASSET
async function handleClickIssueAsset(state, dispatch, popupLayer) {
  let assetCommon;
  let quantity;
  let description;
  let descriptionObj;

  if (Object.keys(state.cartMonaparty).length > 0) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseEmptyTheCartBeforeIssuing[state.language] });
    return { status: 'rejected' };
  }

  // 発行者アドレスチェック

  if (state.issuance.addressIssuer === undefined || state.issuance.addressIssuer === null || state.issuance.addressIssuer === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addressIssuerIsRequired[state.language] });
    return { status: 'rejected' };
  }

  // トークン名生成・チェック

  if (state.issuance.assetType === 'tokenNameLeftToTheSystem') {
    while (true) {
      assetCommon = 'A';

      // 最初の桁は0以外の数字（1〜9）にする
      assetCommon += Math.floor(Math.random() * 9) + 1;

      // 残りの18桁は0〜9のランダムな数字
      for (let i = 2; i <= 19; i++) {
        assetCommon += Math.floor(Math.random() * 10);
      }

      if (!state.assetNames.includes(assetCommon)) {
        break;
      }
    }
  }
  else if (state.issuance.assetType === 'tokenNameSpecified') {
    const regex = /^[B-Z][A-Z]{3,11}$/;

    if (regex.test(state.issuance.assetCommon)) {
      assetCommon = state.issuance.assetCommon;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.theTokenNameDoesNotMeetTheRequirements[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (state.issuance.assetType === 'subAsset') {
    const regex = /^[A-Za-z0-9.\-_@!]+$/;

    if (regex.test(state.issuance.subAsset)) {
      assetCommon = state.issuance.parent + '.' + state.issuance.subAsset;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.theSubAssetNameDoesNotMeetTheRequirements[state.language] });
      return { status: 'rejected' };
    }
  }
  else {
    // unknown asset type
  }
  
  // divible, listed, vendable, reassignableチェック

  if (state.issuance.divisible === undefined || state.issuance.divisible === null) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.divisibleIsRequired[state.language] });
    return { status: 'rejected' };
  }

  if (state.issuance.listed === undefined || state.issuance.listed === null) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.listedIsRequired[state.language] });
    return { status: 'rejected' };
  }

  if (state.issuance.vendable === undefined || state.issuance.vendable === null) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.vendableIsRequired[state.language] });
    return { status: 'rejected' };
  }

  if (state.issuance.reassignable === undefined || state.issuance.reassignable === null) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.reassignableIsRequired[state.language] });
    return { status: 'rejected' };
  }

  if (state.issuance.amount === undefined || state.issuance.amount === null) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.amountToIssueIsRequired[state.language] });
    return { status: 'rejected' };
  }

  // 発行量補正・チェック

  if (state.issuance.divisible === true) {
    quantity = new decimal(state.issuance.amount.value).times(100000000).toNumber();

    if (!Number.isInteger(quantity)) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.limitTheAmountToIssueToEightDecimalPlaces[state.language] });
      return { status: 'rejected' };
    }
  }
  else {
    quantity = state.issuance.amount.value;

    if (!Number.isInteger(quantity)) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.amountToIssueMustBeInteger[state.language] });
      return { status: 'rejected' };
    }
  }

  // description生成・チェック

  try {
    descriptionObj = JSON.parse(state.issuance.description);
  }
  catch (error) {
    description = state.issuance.description;
  }

  // モナカードのときの必須チェック その1

  if (state.issuance.issueMode === 'issueMonacard') {
    if (descriptionObj?.monacard?.name === undefined || descriptionObj.monacard.name === null || descriptionObj.monacard.name === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.monacardNameIsRequired[state.language] });
      return { status: 'rejected' };
    }

    if (descriptionObj?.monacard?.owner === undefined || descriptionObj.monacard.owner === null || descriptionObj.monacard.owner === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.monacardIssuerNameIsRequired[state.language] });
      return { status: 'rejected' };
    }

    if (descriptionObj?.monacard?.desc === undefined || descriptionObj.monacard.desc === null || descriptionObj.monacard.desc === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.monacardDescriptionIsRequired[state.language] });
      return { status: 'rejected' };
    }
  }

  // 既存アセットチェック

  const resultOfGettingAssetInfo = await getAssetInfo({
    dispatch,
    assets: [assetCommon],
    assetInfos: state.assetInfo,
    clientParameters: state.config.clientParameters,
  });

  if (resultOfGettingAssetInfo.status === 'rejected') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.internalServerError[state.language] });
    return { status: 'rejected' };
  }
  else if (resultOfGettingAssetInfo.status === 'fulfilled') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.theAssetHasAlreadyBeenIssued[state.language] });
    return { status: 'rejected' };
  }

  // 画像アップロード&CID取得

  if (state.issuance.imagesNew.monacard !== undefined && state.issuance.imagesNew.monacard !== null) {
    try {
      descriptionObj.monacard.cid = 'dummy';
      const cid = await uploadImageAndGetCid(state, dispatch, ['issuance', 'imagesNew', 'monacard']);
      descriptionObj.monacard.cid = cid;
    }
    catch (error) {
      // 何もしない。
    }
  }

  // モナカードのときの必須チェック その2

  if (state.issuance.issueMode === 'issueMonacard') {
    if (descriptionObj?.monacard?.cid === undefined || descriptionObj.monacard.cid === null || descriptionObj.monacard.cid === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.monacardCidIsRequired[state.language] });
      return { status: 'rejected' };
    }
  }

  if (descriptionObj !== undefined) {
    description = JSON.stringify(descriptionObj);
  }


  const actionItemsMultiSources = addIssuanceToTheCartMonaparty(
    state,
    dispatch,
    state.issuance.addressIssuer,
    assetCommon,
    quantity,
    description,
    state.issuance.divisible,
    state.issuance.listed,
    state.issuance.vendable,
    state.issuance.reassignable,
    state.issuance.assetType,
  );

  const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  for (const address of Object.keys(actionItemsMultiSources)) {
    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[address]) {
      actionItem.status = 'unprocessed';
    }
  }

  const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
  devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

  handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
}
// HANDLE CLICK EDIT ASSET INFO
async function handleClickEditAssetInfo(state, dispatch, popupLayer, editMode) {
  if (Object.keys(state.cartMonaparty).length > 0) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseEmptyTheCartBeforeEditing[state.language] });
    return { status: 'rejected' };
  }

  // description生成・チェック

  let description;
  let descriptionObj;

  try {
    descriptionObj = JSON.parse(state.editAssetInfo.description);
  }
  catch (error) {
    description = state.editAssetInfo.description;
  }

  // モナカードのときの必須チェック その1

  if (state.editAssetInfo.editMode === 'editMonacard') {
    if (descriptionObj?.monacard.name === undefined || descriptionObj.monacard.name === null || descriptionObj.monacard.name === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.monacardNameIsRequired[state.language] });
      return { status: 'rejected' };
    }

    if (descriptionObj?.monacard.owner === undefined || descriptionObj.monacard.owner === null || descriptionObj.monacard.owner === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.monacardIssuerNameIsRequired[state.language] });
      return { status: 'rejected' };
    }

    if (descriptionObj?.monacard.desc === undefined || descriptionObj.monacard.desc === null || descriptionObj.monacard.desc === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.monacardDescriptionIsRequired[state.language] });
      return { status: 'rejected' };
    }
  }

  // 画像アップロード&CID取得

  if (state.editAssetInfo.imagesNew.monacard !== undefined && state.editAssetInfo.imagesNew.monacard !== null) {
    try {
      descriptionObj.monacard.cid = 'dummy';
      const cid = await uploadImageAndGetCid(state, dispatch, ['editAssetInfo', 'imagesNew', 'monacard']);
      descriptionObj.monacard.cid = cid;
    }
    catch (error) {
      // 何もしない。
    }
  }

  // モナカードのときの必須チェック その2

  if (state.editAssetInfo.editMode === 'editMonacard') {
    if (descriptionObj?.monacard.cid === undefined || descriptionObj.monacard.cid === null || descriptionObj.monacard.cid === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.monacardCidIsRequired[state.language] });
      return { status: 'rejected' };
    }
  }

  if (descriptionObj !== undefined) {
    description = JSON.stringify(descriptionObj);
  }


  const actionItemsMultiSources = addEditMonacardToTheCartMonaparty(
    state,
    dispatch,
    editMode,
    state.editAssetInfo.addressOwner,
    state.editAssetInfo.asset,
    state.editAssetInfo.assetCommon,
    // 0, // quantity
    description,
    // state.editAssetInfo.lock,
    state.editAssetInfo.divisible,
    state.editAssetInfo.listed,
    state.editAssetInfo.vendable,
    state.editAssetInfo.reassignable,
  );

  const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  for (const address of Object.keys(actionItemsMultiSources)) {
    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[address]) {
      actionItem.status = 'unprocessed';
    }
  }

  const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
  devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

  handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
}

// HANDLE CLICK ADDITIONAL ISSUANCE
async function handleClickAdditionalIssuance(state, dispatch, popupLayer) {
  if (Object.keys(state.cartMonaparty).length > 0) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseEmptyTheCartBeforeIssuing[state.language] });
    return { status: 'rejected' };
  }

  let quantity;

  if (state.editAssetInfo.divisible === true) {
    quantity = new decimal(state.editAssetInfo.amount.value).times(100000000).toNumber();

    if (!Number.isInteger(quantity)) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.limitTheAmountToIssueToEightDecimalPlaces[state.language] });
      return { status: 'rejected' };
    }
  }
  else {
    quantity = state.editAssetInfo.amount.value;

    if (!Number.isInteger(quantity)) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.amountToIssueMustBeInteger[state.language] });
      return { status: 'rejected' };
    }
  }

  const actionItemsMultiSources = addAdditionalIssuanceToTheCartMonaparty(
    state,
    dispatch,
    state.editAssetInfo.addressOwner,
    state.editAssetInfo.asset,
    state.editAssetInfo.assetCommon,
    quantity,
    state.editAssetInfo.description,
    state.editAssetInfo.divisible,
    state.editAssetInfo.listed,
    state.editAssetInfo.vendable,
    state.editAssetInfo.reassignable,
  );

  const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  for (const address of Object.keys(actionItemsMultiSources)) {
    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[address]) {
      actionItem.status = 'unprocessed';
    }
  }

  const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
  devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

  handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
}

// HANDLE CLICK LOCK ISSUANCE
async function handleClickLockIssuance(state, dispatch, popupLayer) {
  if (state.assetInfo[state.editAssetInfo.asset]?.locked) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.theAssetIsAlreadyLocked[state.language] });
    return { status: 'rejected' };
  }

  if (Object.keys(state.cartMonaparty).length > 0) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseEmptyTheCartBeforeLocking[state.language] });
    return { status: 'rejected' };
  }

  const actionItemsMultiSources = addLockIssuanceToTheCartMonaparty(
    state,
    dispatch,
    state.editAssetInfo.addressOwner,
    state.editAssetInfo.asset,
    state.editAssetInfo.assetCommon,
    state.editAssetInfo.divisible,
    state.editAssetInfo.listed,
    state.editAssetInfo.vendable,
    state.editAssetInfo.reassignable,
  );

  const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  for (const address of Object.keys(actionItemsMultiSources)) {
    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[address]) {
      actionItem.status = 'unprocessed';
    }
  }

  const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
  devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

  handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
}

// HANDLE CLICK TRANSFER OWNERSHIP
async function handleClickTransferOwnership(state, dispatch, popupLayer) {
  if (Object.keys(state.cartMonaparty).length > 0) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseEmptyTheCartBeforeTransferring[state.language] });
    return { status: 'rejected' };
  }

  if (state.editAssetInfo.addressNewOwner === undefined || state.editAssetInfo.addressNewOwner === null || state.editAssetInfo.addressNewOwner === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addressNewOwnerIsRequired[state.language] });
    return { status: 'rejected' };
  }

  if (state.editAssetInfo.addressNewOwner === state.editAssetInfo.addressOwner) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.theNewOwnerIsTheSameAsTheCurrentOwner[state.language] });
    return { status: 'rejected' };
  }

  const actionItemsMultiSources = addTransferOwnershipToTheCartMonaparty(
    state,
    dispatch,
    state.editAssetInfo.addressOwner,
    state.editAssetInfo.asset,
    state.editAssetInfo.assetCommon,
    state.editAssetInfo.addressNewOwner,
    state.editAssetInfo.description,
    state.editAssetInfo.divisible,
    state.editAssetInfo.listed,
    state.editAssetInfo.vendable,
    state.editAssetInfo.reassignable,
  );

  const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  for (const address of Object.keys(actionItemsMultiSources)) {
    ACTION_ITEM: for (const actionItem of actionItemsMultiSources[address]) {
      actionItem.status = 'unprocessed';
    }
  }

  const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
  devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

  handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
}

// FETCH RECENT TXIDS
async function fetchRecentTxids(state, address) {
  if (address === undefined || address === null || address === '') {
    throw new Error('address is required');
  }

  const blockbookConfig = state.config?.clientParameters?.blockbook;

  if (blockbookConfig === undefined || blockbookConfig.domain === undefined || !Array.isArray(blockbookConfig.domain) || blockbookConfig.domain.length === 0) {
    throw new Error('blockbook configuration is not ready');
  }

  if (blockbookConfig.addressPath === undefined) {
    throw new Error('blockbook address path is not defined');
  }

  let serverIndex = 0;
  const encodedAddress = encodeURIComponent(address);
  const overridePageSize = Number(state.getHistoryInBlockChain?.pageSize);
  const overrideMaxPages = Number(state.getHistoryInBlockChain?.maxPages);
  const pageSize = Number.isFinite(overridePageSize) && overridePageSize > 0 ? overridePageSize : 1000;
  const maxPages = Number.isFinite(overrideMaxPages) && overrideMaxPages > 0 ? overrideMaxPages : 1000;
  const normalizedAddressForClassification = (address ?? '').trim().toLowerCase();

  const gatherAddressesFromIo = (io) => {
    const candidates = [];

    if (io === undefined || io === null) {
      return candidates;
    }

    if (Array.isArray(io.addresses)) {
      candidates.push(...io.addresses);
    }

    if (typeof io.address === 'string') {
      candidates.push(io.address);
    }

    if (Array.isArray(io.addr)) {
      candidates.push(...io.addr);
    }
    else if (typeof io.addr === 'string') {
      candidates.push(io.addr);
    }

    if (io.prevout !== undefined && io.prevout !== null) {
      if (Array.isArray(io.prevout.addresses)) {
        candidates.push(...io.prevout.addresses);
      }

      if (typeof io.prevout.address === 'string') {
        candidates.push(io.prevout.address);
      }
    }

    return candidates;
  };

  const ioListIncludesNormalizedAddress = (ioList) => {
    if (!normalizedAddressForClassification) {
      return false;
    }

    if (!Array.isArray(ioList)) {
      return false;
    }

    for (const io of ioList) {
      const addresses = gatherAddressesFromIo(io);

      for (const candidate of addresses) {
        if (typeof candidate === 'string' && candidate.trim().toLowerCase() === normalizedAddressForClassification) {
          return true;
        }
      }
    }

    return false;
  };

  const classifyTransactionAddressInvolvement = (transaction) => {
    if (!normalizedAddressForClassification) {
      return 'NONE';
    }

    const isInput = ioListIncludesNormalizedAddress(transaction?.vin);
    const isOutput = ioListIncludesNormalizedAddress(transaction?.vout);

    if (isInput && isOutput) {
      return 'BOTH';
    }

    if (isInput) {
      return 'IN';
    }

    if (isOutput) {
      return 'OUT';
    }

    return 'NONE';
  };

  const applyAddressInvolvement = (transactions) => {
    if (!Array.isArray(transactions)) {
      return;
    }

    for (const transaction of transactions) {
      if (transaction !== undefined && transaction !== null && typeof transaction === 'object') {
        transaction.addressInvolvement = classifyTransactionAddressInvolvement(transaction);
      }
    }
  };

  let request = {};
  request.method = 'GET';
  request.headers = {
    'Accept': 'application/json',
  };

  SERVER: while (true) {
    try {
      const allTransactions = [];
      const seenTxids = new Set();
      let page = 1;

      while (true) {
        request.url = `https://${blockbookConfig.domain[serverIndex]}${blockbookConfig.addressPath}${encodedAddress}?details=txs&page=${page}&pageSize=${pageSize}`;
        devLog('fetch recent txids; request', JSON.stringify(request));

        const response = await syncHttpRequestOrThrow(request);
        devLog('fetch recent txids; response', JSON.stringify(response));

        const transactions = Array.isArray(response?.transactions) ? response.transactions : [];

        for (const transaction of transactions) {
          const txid = transaction?.txid;

          if (txid === undefined || txid === null || txid === '') {
            allTransactions.push(transaction);
            continue;
          }

          if (seenTxids.has(txid)) {
            continue;
          }

          seenTxids.add(txid);

          allTransactions.push(transaction);
        }

        const itemsOnPage = Number(response?.itemsOnPage);
        const totalPages = Number(response?.totalPages);
        const currentPage = Number(response?.page) || page;

        const reachedLastPage = (
          Number.isFinite(totalPages) && currentPage >= totalPages
        ) || transactions.length < pageSize || (Number.isFinite(itemsOnPage) && itemsOnPage < pageSize);

        if (reachedLastPage) {
          applyAddressInvolvement(allTransactions);
          return allTransactions;
        }

        page = currentPage + 1;

        if (page > maxPages) {
          throw new Error('too many pages while fetching transactions');
        }
      }
    }
    catch (error) {
      devLog('fetch recent txids; rejected', error);

      if (serverIndex >= blockbookConfig.domain.length - 1) {
        throw new Error(String(error || 'failed to fetch recent txids'));
      }
      else {
        serverIndex++;
        continue SERVER;
      }
    }
  }
}

// FIRST TRANSACTION RITUAL
async function firstTransactionRitual(state, dispatch, popupLayer) {
  let addressMain;

  if (state.active.addressMain !== undefined && state.active.addressMain !== null) {
    addressMain = state.active.addressMain;
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseLogin[state.language] });
    return { status: 'rejected' };
  }

  let balanceMonaparty;
  let balanceMonapartyArray;

  if (state.balance.monaparty[addressMain] !== undefined) {
    balanceMonaparty = state.balance.monaparty[addressMain];
    balanceMonapartyArray = Object.keys(balanceMonaparty);
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseLogin[state.language] });
    return { status: 'rejected' };
  }

  // 送信トークン選択

  let asset;

  // MONADOMREPを優先的に選択

  const monadomreps = balanceMonapartyArray.filter( asset => {
    if (balanceMonaparty[asset].asset_longname !== undefined && balanceMonaparty[asset].asset_longname !== null) {
      return balanceMonaparty[asset].asset_longname.startsWith('MONADOMREP');
    }
    else {
      return false;
    }
  });

  if (monadomreps.length >= 1) {
    asset = monadomreps[0];
  }
  else if (balanceMonapartyArray.length >= 1) {
    asset = balanceMonapartyArray[0];
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.youDoNotHaveAnyTokensWithThisAddressPleaseGetSomeTokensSomehow[state.language] });
    return { status: 'rejected' };
  }

  // 数量決定

  let quantity;

  if (state.assetInfo[asset] !== undefined) {
    if (state.assetInfo[asset].divisible === true) {
      quantity = new decimal(1).times(100000000).toNumber();
    }
    else {
      quantity = 1;
    }
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseLogin[state.language] });
    return { status: 'rejected' };
  }

  // カートを一回空にしてから追加

  const actionItemsMultiSources = addTokensToTheCartMonapartyAfterEmptying(state, dispatch, addressMain, addressMain, asset, quantity);

  // トランザクション作成

  const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });
  const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
  devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

  // ブロードキャスト

  handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
}

// eslint-disable-next-line no-unused-vars
async function handleClickSendMona(state, dispatch, popupLayer) {
  let request = {};
  let response = {};
  let stateFixed = {};
  let messages = {};
  let utxos;
  let utxosSelected;
  let approximatedTransactionBytes;
  let feeRate;
  let transactionFee;
  let change;
  let amountToPay;
  let inputs;
  let outputs;
  let unsignedTransaction;

  // state固定
  if (popupLayer !== undefined && popupLayer !== null) {
    stateFixed = {
      addressPayFrom: state.purchase.addressPayFrom,
      addressPayProceedsTo: state.popup[popupLayer].body.addressPayProceedsTo,
      addressPayRoyaltyTo: state.purchase.addressPayRoyaltyTo,
      monacottoAddressMona: state.config.monacottoAddress.monacottoAddressMona,
      amountToBuy: state.purchase.amountToBuy,
      priceMona: state.popup[popupLayer].body.priceMona,
      priceMonaWatanabe: state.popup[popupLayer].body.priceMonaWatanabe,
      proceedsNetMona: state.popup[popupLayer].body.proceedsNetMona,
      royaltyMona: state.popup[popupLayer].body.royaltyMona,
      feeMona: state.popup[popupLayer].body.feeMona,
      provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
      transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
      addressMain: state.purchase.addressMain,
      purchaseNo: state.purchase.purchaseNo,
      signatureByAddressMain: state.purchase.signatureByAddressMain,
    };
  }
  else {
    stateFixed = {
      addressPayFrom: state.purchase.addressPayFrom,
      addressPayProceedsTo: state.itemDetail.item.addressPayProceedsTo,
      addressPayRoyaltyTo: state.purchase.addressPayRoyaltyTo,
      monacottoAddressMona: state.config.monacottoAddress.monacottoAddressMona,
      amountToBuy: state.purchase.amountToBuy,
      priceMona: state.itemDetail.item.priceMona,
      priceMonaWatanabe: state.itemDetail.item.priceMonaWatanabe,
      proceedsNetMona: state.itemDetail.item.proceedsNetMona,
      royaltyMona: state.itemDetail.item.royaltyMona,
      feeMona: state.itemDetail.item.feeMona,
      provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
      transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
      addressMain: state.purchase.addressMain,
      purchaseNo: state.purchase.purchaseNo,
      signatureByAddressMain: state.purchase.signatureByAddressMain,
    };
  }

  if (window.mpurse) {
    // Mpurseのアドレスが合ってるかチェック
    let result = await window.mpurse.getAddress()
      .then( (result) => {
        if (result !== stateFixed.addressPayFrom) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressFilledAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          return 'fulfilled';
        }
      })
      .catch( (error) => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
          devLog('CNBG', error);
          return 'rejected';
      });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // UTXO取得

    // request.url = `https://${state.config.blockbook.domain}${state.config.blockbook.utxoPath}${stateFixed.addressPayFrom}`;
    // request.method = 'GET';
    // request.headers = {
    //   'Accept': 'application/json',
    // };

    // devLog('get UTXO; request', JSON.stringify(request));

    // response = await syncHttpRequest(request);

    response = await getUtxo({ clientParameters: state.config.clientParameters, address: stateFixed.addressPayFrom });

    if ( response.status === 'fulfilled' ) {
      utxos = response.body;
      devLog('utxos', JSON.stringify(utxos));
    }
    else {
      devLog('get UTXO; rejected');
      return { status: 'rejected' };
    }

    // UTXO選定
    devLog('priceMona', stateFixed.priceMona, 'amountToBuy', stateFixed.amountToBuy, 'provisionalTransactionFee', stateFixed.provisionalTransactionFee);

    utxos.sort( (a, b) => a.amount - b.amount );
    utxosSelected = selectUtxoMona(utxos, stateFixed.priceMona * stateFixed.amountToBuy + stateFixed.provisionalTransactionFee); // boundaryは概算。provisionalTransactionFeeには少し余裕をもたせるべし。
    devLog('utxosSelected', JSON.stringify(utxosSelected));

    if (utxosSelected === null) {
      devLog('short of MONA');
      return { status: 'rejected' };
    }

    // UTX raw transaction取得
    result = await getRawTransaction(state, utxosSelected);

    // request.url = 'https://monapa.electrum-mona.org/_api';
    // // request.url = 'https://wallet.monaparty.me/_api';
    // // request.url = 'https://counterblock.api.monaparty.me/';
    // request.method = 'POST';

    // for (const utxo of utxosSelected) {
    //   request.body = `{"jsonrpc":"2.0","id":0,"method":"proxy_to_counterpartyd","params":{"method":"getrawtransaction","params":{"tx_hash":"${utxo.txid}"}}}`;
    //   devLog('get UTX raw transaction; request', JSON.stringify(request));

    //   response = await syncHttpRequest(request);
    //   devLog('get UTX raw transaction; response', JSON.stringify(response));

    //   utxo.rawTransaction = response.body.result;
    // }

    // 概算バイト数計算
    approximatedTransactionBytes = 1000;

    // fee rate取得

    // request.url = `https://${state.config.blockbook.domain}${state.config.blockbook.feePath}${state.config.blockbook.feeBlocks}`;
    // request.method = 'GET';
    // request.headers = {
    //   'Accept': 'application/json',
    // };
    // delete request.body;

    // devLog('get fee rate; request', JSON.stringify(request));

    // response = await syncHttpRequest(request);

    response = await getFeeRate({ clientParameters: state.config.clientParameters });

    if ( response.status === 'fulfilled' ) {
      // if (response.body.result === '0') {
      //   feeRate = 0.002;
      // }
      // else {
      //   feeRate = toFloat(response.body.result);
      // }

      feeRate = response.body;
      devLog('feeRate', feeRate);
    }
    else {
      devLog('get fee rate; rejected');
      return { status: 'rejected' };
    }

    // transaction fee, change, amountToPay計算 (transactionFeeはここまで丁寧にする必要なし。)
    const feeRateDecimal = new decimal(feeRate); // MONA/KB = 10^8watanabe/10^3byte = 10^5watanabe/byte
    transactionFee = decimalAdjust( 'floor',  feeRateDecimal.times(100000).times(approximatedTransactionBytes).toNumber(), 0 ); 
    amountToPay = stateFixed.priceMonaWatanabe * stateFixed.amountToBuy + transactionFee;
    change = utxosSelected.reduce( (acc, cur) => acc + cur.satoshis, 0 ) - amountToPay;
    devLog(`transactionFee ${transactionFee}, amountToPay ${amountToPay}, change ${change}`);

    // transactionFee歯止め
    if (transactionFee > stateFixed.transactionFeeUpperBound) {
      devLog('transactionFee is too high.');
      return { status: 'rejected' };
    }

    // トランザクション作成
    inputs = utxosSelected.map( utxo => {
      return {
        txid: utxo.txid,
        vout: utxo.vout,
        rawTransaction: utxo.rawTransaction,
      };
    });

    devLog('inputs', JSON.stringify(inputs));

    if (stateFixed.royaltyMona > 0) {
      outputs = [
        {
          address: stateFixed.addressPayProceedsTo,
          amount: stateFixed.proceedsNetMona * stateFixed.amountToBuy,
        },
        {
          address: stateFixed.addressPayRoyaltyTo,
          amount: stateFixed.royaltyMona * stateFixed.amountToBuy,
        },
        {
          address: stateFixed.monacottoAddressMona,
          amount: stateFixed.feeMona * stateFixed.amountToBuy,
        },
        {
          address: stateFixed.addressPayFrom,
          amount: change,
        },
      ];
    }
    else {
      outputs = [
        {
          address: stateFixed.addressPayProceedsTo,
          amount: stateFixed.proceedsNetMona * stateFixed.amountToBuy,
        },
        {
          address: stateFixed.monacottoAddressMona,
          amount: stateFixed.feeMona * stateFixed.amountToBuy,
        },
        {
          address: stateFixed.addressPayFrom,
          amount: change,
        },
      ];
    }

    devLog('outputs', JSON.stringify(outputs));

    request.body = JSON.stringify({
      body: {
        inputs: inputs,
        outputs: outputs,
      }
    });

    request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/build_transaction_mona';
    request.method = 'POST'; // ← 使われない
    request.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }; // ← 使われない

    messages = {
    };

    response = await syncHttpRequest2(request, undefined, undefined, undefined, messages, dispatch);
    devLog('build transaction; response', JSON.stringify(response));

    if ( response.status === 'fulfilled' ) {
      unsignedTransaction = response.body.unsignedTxHex;
    }
    else {
      devLog('failed to build transaction.');
      return { status: 'rejected' };
    }

    devLog('unsignedTransaction bytes', (new Blob([unsignedTransaction])).size);

    // GO!
    // ポップアップで送金内容確認してもらったらGO!
    const popup = {
      type: 'sendMonaConfirmation',
      body: {
        addressPayProceedsTo: stateFixed.addressPayProceedsTo,
        addressPayRoyaltyTo: stateFixed.addressPayRoyaltyTo,
        monacottoAddressMona: stateFixed.monacottoAddressMona,
        proceedsNetMona: stateFixed.proceedsNetMona * stateFixed.amountToBuy,
        royaltyMona: stateFixed.royaltyMona * stateFixed.amountToBuy,
        feeMona: stateFixed.feeMona * stateFixed.amountToBuy,
        transactionFee: transactionFee,
      },
    };

    if (wallet === 'MonaPallet') {
      popup.extendedClassesBackGround = 'alignItemsFlexStart';
    }
    else { // Mpurse
    }

    dispatch({ type: 'setStateMultiLayers', keys: ['popup', (popupLayer !== undefined && popupLayer !== null) ? (popupLayer + 1) : 0], value: popup });

    result = await window.mpurse.sendRawTransaction(unsignedTransaction)
      .then( async (result) => {
        devLog(result);
        // devLog('signedTransaction bytes', (new Blob([signedTransaction])).size);

        // purchase状態更新(部分クリア)
        dispatch({ type: 'setState', key: 'purchase',
          value: {
            purchaseNo: null,
            addressMain: state.purchase.addressMain,
            addressPayFrom: state.purchase.addressPayFrom,
            addressSendCardTo: state.purchase.addressSendCardTo,
            addressMainExhibitor: '',
            exhibitNo: '',
            amountToBuy: state.purchase.amountToBuy,
            signatureByAddressMain: '',
            signatureByAddressPayFrom: '',
            addressPayRoyaltyTo: null,
            disabled: false,
            status: 'waitingForSignature',
          }
        });

        // notification
        dispatch({ type: 'setNotification', key: 'notification', value: words.sentSuccessfully[state.language] + ' ' + result });

        // トークン送信成功通知
        request.body = JSON.stringify({
          "body": {
            addressMain: stateFixed.addressMain,
            purchaseNo: stateFixed.purchaseNo,
            signatureByAddressMain: stateFixed.signatureByAddressMain,
            sendMonaTxid: result,
          }
        });
        request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/notify_sending_mona';
        request.method = 'POST';
        messages = {
        };

        await syncHttpRequest2(request, undefined, undefined, undefined, messages, dispatch);
        return 'fulfilled';
      })
      .catch( (error) => {
        devLog(error);
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSend[state.language] });
        return 'rejected';
      });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.activateMpurse[state.language] });
    return { status: 'rejected' };
  }

  return { status: 'fulfilled' };
}

// HANDLE CLICK SWAP MNEMONICS
async function handleClickSwapMnemonics(state, dispatch) {
  const swapStatus = localStorage.getItem('swapStatus');
  // const oldAddress = localStorage.getItem('oldAddress');
  const oldMnemonic = localStorage.getItem('oldMnemonic');
  const oldKeyPair = getKeyPairsFromMnemonic({ dispatch, network: state.networkMona, mnemonic: oldMnemonic, language: state.language })[0];
  const newAddress = localStorage.getItem('newAddress');
  const newMnemonic = localStorage.getItem('newMnemonic');
  const sweepAssetsTxid = localStorage.getItem('sweepAssetsTxid');
  const sweepMonaTxid = localStorage.getItem('sweepMonaTxid');

  // devLog('swapStatus', swapStatus);
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: swapStatus });

  if (swapStatus === undefined || swapStatus === null) {
    // ニュートラル状態だから、はじめるよ！
    // まず新しいニーモニックを生成して、それと古いニーモニックをローカルストレージに保存するよ。
    // localStorage.setItem('swapStatus', 'keepingMnemonics');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: 'keepingMnemonics' }); // 暫定

    const callback = (mnemonics, keyPairs) => keepMnemonics(state, dispatch, mnemonics, keyPairs);
    handleClickNfc(state, dispatch, callback, { args: ['mnemonics', 'keyPairs'] });
  }
  else if (swapStatus === 'keptMnemonics') {
    // トークンをスウィープするよ！
    // localStorage.setItem('swapStatus', 'transfering');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: 'transfering' }); // 暫定

    const result = await sweepAssets(state, dispatch, oldKeyPair, newAddress);

    if (result.status === 'fulfilled') {
      const txid = result.body;
      localStorage.setItem('sweepAssetsTxid', txid);
      localStorage.setItem('swapStatus', 'sweepingAssets');
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'sweepAssetsTxid ' + txid }); // 暫定
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'sweep assets; rejected ' + JSON.stringify(result.error) }); // 暫定
      throw new Error(result.error);
    }
  }
  else if (swapStatus === 'sweepingAssets') {
    // トークンスウィープが承認されたかどうかチェックするよ！
    let confirmations;
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: 'transfered' }); // 暫定

    const result = await getTransaction(state, sweepAssetsTxid);

    if (result.status === 'fulfilled') {
      confirmations = result.body.confirmations;
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'confirmations of sweep assets ' + confirmations }); // 暫定
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'sweep assets; rejected ' + JSON.stringify(result.error) }); // 暫定
      throw new Error(result.error);
    }

    if (confirmations >= 1) {
      localStorage.setItem('swapStatus', 'sweptAssets');
    }
    else {
      return {
        status: 'rejected',
        error: 'not confirmed yet.',
      };
    }

    // MONA移転するぞ！
    handleClickSwapMnemonics(state, dispatch);
  }
  else if (swapStatus === 'sweptAssets') {
    // トークンスウィープが完了したので、MONA移転するよ！
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: 'transfering MONA' }); // 暫定

    const result = await sweepMona(state, dispatch, oldKeyPair, newAddress);

    if (result.status === 'fulfilled') {
      const txid = result.body;
      localStorage.setItem('sweepMonaTxid', txid);
      localStorage.setItem('swapStatus', 'sweepingMona');
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'sweepMonaTxid ' + txid }); // 暫定
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'sweep MONA; rejected ' + JSON.stringify(result.error) }); // 暫定
      throw new Error(result.error);
    }

  }
  else if (swapStatus === 'sweepingMona') {
    // MONA移転が承認されたかどうかチェックするよ！
    let confirmations;
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: 'transfered' }); // 暫定

    const result = await getTransaction(state, sweepMonaTxid);

    if (result.status === 'fulfilled') {
      confirmations = result.body.confirmations;
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'confirmations of send MONA ' + confirmations }); // 暫定
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'sweep assets; rejected ' + JSON.stringify(result.error) }); // 暫定
      throw new Error(result.error);
    }

    if (confirmations >= 1) {
      localStorage.setItem('swapStatus', 'sweptMona');
    }
    else {
      return {
        status: 'rejected',
        error: 'not confirmed yet.',
      };
    }

    // 移転完了NFCタグに書き込むぞ！

    handleClickSwapMnemonics(state, dispatch);
  }
  else if (swapStatus === 'sweptMona') {
    // MONA移転が完了したので、NFCタグ書き換えるよ！
    let newMnemonicEncrypted;

    // localStorage.setItem('swapStatus', 'transfered');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: 'transfered' }); // 暫定

    const password = state.config.clientParameters.specialMessage;
    const salt = ['00', '00', '00', '00', '00', '00', '00', '72'];
    const iv = ['00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '00', '01', 'bf', '52'];

    try {
      newMnemonicEncrypted = await encrypt(state, dispatch, newMnemonic, password, salt, iv);
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'new mnemonic encrypted ' + newMnemonicEncrypted }); // 暫定
      // await setTimeout(10000);
      await sleep(10000);
    }
    catch (error) {
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'new mnemonic encrypted; rejected ' + error }); // 暫定
      throw new Error(error);
    }

    try {
      await writeOnNfc(state, dispatch, newMnemonicEncrypted);
      localStorage.setItem('swapStatus', 'wroteMnemonic');
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'write mnemonic succeeded.' }); // 暫定
    }
    catch (error) {
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'write mnemonic; rejected ' + error }); // 暫定
      throw new Error(error);
    }

    // NFCタグちゃんと書き込まれたかチェックするぞ！

    handleClickSwapMnemonics(state, dispatch);
  }
  else if (swapStatus === 'wroteMnemonic') {
    // NFCタグ書き込みが完了したので、ちゃんと書き込まれたかチェックするよ！

    // localStorage.setItem('swapStatus', 'transfered');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: 'transfered' }); // 暫定

    const callback = (mnemonics) => checkMnemonicOnNfc(state, dispatch, newMnemonic, mnemonics);
    handleClickNfc(state, dispatch, callback, { args: ['mnemonics'] });
  }
  else if (swapStatus === 'transfered') {
    localStorage.removeItem('swapStatus');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: '' }); // 暫定
  }
  else if (swapStatus === 'keepingMnemonics' || swapStatus === 'transfering') {
    localStorage.removeItem('swapStatus');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: '' });
  }
  else {
    devLog('swapStatus', swapStatus);
  }

  // if (swapStatus === undefined || swapStatus === null) {
  //   localStorage.setItem('swapStatus', 'readOldMnemonic');
  // }
  // else if (swapStatus === 'readOldMnemonic') {
  //   localStorage.setItem('swapStatus', 'keptMnemonics');
  // }
  // else if (swapStatus === 'keptMnemonics') {
  //   localStorage.setItem('swapStatus', 'sentToken');
  // }
  // else if (swapStatus === 'sentToken') {
  //   localStorage.setItem('swapStatus', 'sentMona');
  // }
  // else if (swapStatus === 'sentMona') {
  //   localStorage.setItem('swapStatus', 'confirmSentToken');
  // }
  // else if (swapStatus === 'confirmSentToken') {
  //   localStorage.setItem('swapStatus', 'confirmSentMona');
  // }
  // else if (swapStatus === 'confirmSentMona') {
  //   localStorage.setItem('swapStatus', 'transferMonatokaPoint');
  // }
  // else if (swapStatus === 'transferMonatokaPoint') {
  //   localStorage.removeItem('swapStatus');
  // }
  // else {
  //   devLog('swapStatus', swapStatus);
  // }
}

// KEEP MNEMONICS
function keepMnemonics(state, dispatch, oldMnemonics, oldKeyPairs) {
  let oldAddress;
  // let newMnemonic;
  // let newAddress;
  let result;

  // 旧アドレス取得

  result = getAddressFromKey(state, dispatch, oldKeyPairs[0], state.networkMona);

  if (result.status === 'fulfilled') {
    oldAddress = result.address;
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
    return 'rejected';
  }

  // 新ニーモニック生成

  const { mnemonic: newMnemonic, address: newAddress } = generateMnemonic({ dispatch, network: state.networkMona, language: state.language });

  // if (result.status === 'fulfilled') {
  //   newMnemonic = result.mnemonic;
  //   newAddress = result.address;
  // }
  // else {
  //   dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: 'error keepMnemonics' });
  //   return;
  // }

  localStorage.setItem('oldMnemonic', oldMnemonics[0]);
  localStorage.setItem('oldKeyPair', oldKeyPairs[0]);
  localStorage.setItem('oldAddress', oldAddress);
  localStorage.setItem('newMnemonic', newMnemonic);
  localStorage.setItem('newAddress', newAddress);
  localStorage.setItem('swapStatus', 'keptMnemonics');

  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: localStorage.getItem('oldMnemonic') + ' : ' + newMnemonic + ' : ' + localStorage.getItem('oldKeyPair') }); // 暫定

  // 移転するぞ！

  // handleClickSwapMnemonics(state, dispatch);
}

// NFC読み込み READ NFC
// eslint-disable-next-line no-unused-vars
async function readNfc(state, dispatch, encryptedMnemonic) {
  if (!('NDEFReader' in window)) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.yourDeviceDoesNotSupportKeyCards[state.language] });
    return;
  }

  const ndef = new window.NDEFReader();

  const result = await ndef.write({
    records: [
      {
        recordType: "url",
        data: "https://knightsofmonadom.monatoka.com/?wallettype=nfc"
      },
      {
        recordType: "text",
        lang: "en",
        encoding: "utf-8",
        data: encryptedMnemonic,
        // data: state.displaySecret.mnemonicToWif,
      },
    ]
  })
  .then( (result) => {
    dispatch({ type: 'setNotification', key: 'notification', value: 'NDEF messages written!' });
    return;
  })
  .catch( (error) => {
    dispatch({ type: 'setNotification', key: 'notification', value: 'Failed to write NDEF messages.' });
    throw new Error(error);
  });

  return result;
}

// NFC書き込んだニーモニックチェック CHECK MNEMONIC ON NFC
function checkMnemonicOnNfc(state, dispatch, mnemonicToBeWritten, mnemonicsWritten) {
  if (mnemonicToBeWritten === mnemonicsWritten[0]) {
    localStorage.setItem('swapStatus', 'checkedMnemonic');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'check mnemonic OK.' }); // 暫定
  }
  else {
    localStorage.setItem('swapStatus', 'sweptMona');
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'check mnemonic NG.' }); // 暫定
  }
}

// SWEEP MONA
async function sweepMona(state, dispatch, keyPair, addressTo, { sweepFlag = 3 } = {}) {
  let result;
  let addressFrom;
  let utxos;
  let allMonaBalance;
  let feeRate;
  let unsignedTxHex;
  let signedTxHex;
  let txid;

  const provisionalTransactionFee = state.config.clientParameters.provisionalTransactionFee;
  const transactionFeeUpperBound = state.config.clientParameters.transactionFeeUpperBound;

  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'tra MONA' }); // 暫定

  // 旧アドレス取得

  result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

  if (result.status === 'fulfilled') {
    addressFrom = result.address;
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
    throw new Error(result);
  }

  devLog('provisionalTransactionFee', provisionalTransactionFee);

  // UTXO取得
  result = await getUtxo({ clientParameters: state.config.clientParameters, address: addressFrom });

  if (result.status === 'fulfilled') {
    utxos = result.body;
  }
  else {
    devLog('failed to get UTXO.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + result.error });
    return {
      status: 'rejected',
      error: 'failed to get UTXO.',
    };
  }

  // UTX raw transaction取得
  result = await getRawTransaction(state, utxos);

  if (result.status === 'rejected') {
    devLog('failed to get unspent raw transactions.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '3' });
    return {
      status: 'rejected',
      error: 'failed to get unspent raw transactions.',
    };
  }

  // 全MONA計算

  result = await getAddressInfo({ clientParameters: state.config.clientParameters, address: addressFrom });

  if (result.status === 'fulfilled') {
    allMonaBalance = result.body.balance;
  }
  else {
    devLog('failed to get address info.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '3.5' });

    return {
      status: 'rejected',
      error: 'failed to get address info.',
    };
  }

  // const allMonaBalance = utxos.reduce( (acc, cur) => {
  //   cur.vout
  //   acc + cur
  // }, 0);

  // fee rate取得
  result = await getFeeRate({ clientParameters: state.config.clientParameters });

  if (result.status === 'fulfilled') {
    feeRate = result.body;
  }
  else {
    devLog('failed to get fee rate.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '4' });
    return {
      status: 'rejected',
      error: 'failed to get fee rate.',
    };
  }

  // 概算バイト数計算
  const approximatedTransactionBytes = 1000;

  // transactionFee計算

  const feeRateDecimal = new decimal(feeRate); // MONA/KB = 10^8watanabe/10^3byte = 10^5watanabe/byte
  const transactionFee = decimalAdjust( 'floor',  feeRateDecimal.times(100000).times(approximatedTransactionBytes).toNumber(), 0 ); 
  devLog(`transactionFee ${transactionFee}`);

  // transactionFee歯止め
  if (transactionFee > transactionFeeUpperBound) {
    devLog('transactionFee is too high.');
    return {
      status: 'rejected',
      error: 'transactionFeeIsTooHigh',
    };
  }

  // トランザクション作成
  const inputs = utxos.map( utxo => {
    return {
      txid: utxo.txid,
      vout: utxo.vout,
      rawTransaction: utxo.rawTransaction,
    };
  });

  devLog('inputs', JSON.stringify(inputs));

  const outputs = [
    {
      address: addressTo,
      amount: allMonaBalance - transactionFee,
    },
  ];

  devLog('outputs', JSON.stringify(outputs));

  result = buildUnsignedTransactionSendMona(state.networkMona, inputs, outputs);

  if (result.status === 'fulfilled') {
    unsignedTxHex = result.body;
  }
  else {
    devLog('failed to build transaction.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '6' });
    return {
      status: 'rejected',
      error: result.error,
    };
  }

  // トランザクション署名
  result = signTransaction(state.networkMona, unsignedTxHex, keyPair);

  if (result.status === 'fulfilled') {
    signedTxHex = result.body;
  }
  else {
    devLog('failed to sign transaction.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '7' });
    return {
      status: 'rejected',
      error: result.error,
    };
  }

  // ブロードキャスト
  result = await broadcastTransaction({ clientParameters: state.config.clientParameters, signedTxHex });

  if (result.status === 'fulfilled') {
    txid = result.body;
  }
  else {
    devLog('failed to broadcast transaction.');
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '8' });
    return {
      status: 'rejected',
      error: 'failed to broadcast transaction.',
    };
  }

  return {
    status: 'fulfilled',
    body: txid,
  };
}

// SWEEP ASSETS
async function sweepAssets(state, dispatch, oldKeyPair, newAddress) {
  let oldAddress;
  let balanceAssets;
  let ownedAssets;
  let sweepAssetsTxid;
  let result;

  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'tra tra' + oldKeyPair.privateKey }); // 暫定

  // 旧アドレス取得

  result = getAddressFromKey(state, dispatch, oldKeyPair, state.networkMona);

  if (result.status === 'fulfilled') {
    oldAddress = result.address;
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
    throw new Error(result);
  }

  // モナパトークン保有チェック

  result = await getBalancesMonaparty({ dispatch, address: oldAddress, clientParameters: state.clientParameters })

  if (result.status === 'fulfilled') {
    balanceAssets = result.bodyArray;
  }
  else {
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'balance' + JSON.stringify(result.error) }); // 暫定
    throw new Error(result);
  }

  // モナパトークンオウンチェック

  result = await getOwnedAssets({ dispatch, address: oldAddress, clientParameters: state.clientParameters })

  if (result.status === 'fulfilled') {
    ownedAssets = result.bodyArray;
  }
  else {
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'own' + JSON.stringify(result.error) }); // 暫定
    throw new Error(result);
  }

  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: `balance: ${balanceAssets.length}, own: ${ownedAssets.length}` }); // 暫定

  if (balanceAssets.length > 0 || ownedAssets.length > 0) {
    // モナパトークンsweep

    result = await sweepAssetsSequence(state, dispatch, oldKeyPair, newAddress);

    if (result.status === 'fulfilled') {
      sweepAssetsTxid = result.body;
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'sweep assets ' + JSON.stringify(result.error) }); // 暫定
      throw new Error(result);
    }
  }
  else {
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: 'no asset' }); // 暫定

    return {
      status: 'rejected',
      error: 'no asset',
    };
  }

  return {
    status: 'fulfilled',
    body: sweepAssetsTxid,
  };
}

// SWEEP ASSETS SEQUENCE
async function sweepAssetsSequence(state, dispatch, keyPair, addressTo, { sweepFlag = 3 } = {}) {
  let requestToCounterblockMona = {};
  let bodyObject = {};
  let addressFrom;
  let result;
  let response = {};
  let transactionUnsigned;
  let transactionSigned;
  let txid;
  let serverIndex = 0;

  // requestToCounterblockMona.url = 'https://monapa.electrum-mona.org/_api';
  // requestToCounterblockMona.url = 'https://wallet.monaparty.me/_api';
  // requestToCounterblockMona.url = 'https://counterblock.api.monaparty.me/';

  requestToCounterblockMona.method = 'POST';

  dispatch({ type: 'setNotification', key: 'notification', value: 'start sweepAssetsSequence.' });

  // sweep元アドレス取得

  result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

  if (result.status === 'fulfilled') {
    addressFrom = result.address;
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
    return result;
  }

  // トランザクション作成

  bodyObject = {
    "jsonrpc":"2.0",
    "id":0,
    "method":"proxy_to_counterpartyd",
    "params":{
      "method":"create_sweep",
      "params": {
        "source": addressFrom,
        "destination": addressTo,
        "flags": sweepFlag,
      }
    }
  };

  requestToCounterblockMona.body = JSON.stringify(bodyObject);

  let buildTransactionRetryCount = 0;

  while (response.status !== 'fulfilled') {
    requestToCounterblockMona.url = `https://${state.config.clientParameters.monapaServer.domainAndPath[serverIndex]}`;
    console.log('request create_sweep', JSON.stringify(requestToCounterblockMona));

    response = await syncHttpRequest(requestToCounterblockMona);
    console.log('response', JSON.stringify(response));

    if (response.status === 'rejected') {
      devLog('create_sweep to counterpartyd; rejected');
      dispatch({ type: 'setNotification', key: 'notification', value: 'create_sweep to counterpartyd; rejected' });
      buildTransactionRetryCount++;

      if (serverIndex >= state.config.clientParameters.monapaServer.domainAndPath.length - 1) {
        serverIndex = 0;
      }
      else {
        serverIndex++;
      }

      await sleep(state.config.clientParameters.retry.buildTransaction.retryWaitingTime);
      // await setTimeout(state.config.clientParameters.retry.buildTransaction.retryWaitingTime);
      // keepSqsMessage = true;
      // continue;
    }
    else {
      transactionUnsigned = response.body.result;
      devLog('transactionUnsigned', transactionUnsigned);
      dispatch({ type: 'setNotification', key: 'notification', value: 'create_sweep to counterpartyd; succeeded ' + JSON.stringify(response.body) });
    }

    if (buildTransactionRetryCount > state.config.clientParameters.retry.buildTransaction.retryMax) {
      // -- retry over エラー終了
      devLog('build transaction retry over.');
      dispatch({ type: 'setNotification', key: 'notification', value: 'build transaction retry over.' });
      dispatch({ type: 'setNotification', key: 'notification', value: 'failed to build transaction.' });
      return result;
    }
  }


  // トランザクション署名

  result = {};
  let signTransactionRetryCount = 0;

  while (result.status !== 'fulfilled') {
    result = signTransaction(state.networkMona, transactionUnsigned, keyPair);
    devLog('sign transaction; result', JSON.stringify(result));

    if (result.status === 'fulfilled') {
      devLog('succeeded to sign transaction.');
      transactionSigned = result.body;
      dispatch({ type: 'setNotification', key: 'notification', value: 'succeeded to sign transaction. ' + transactionSigned });
    }
    else {
      devLog('failed to sign transaction.');
      dispatch({ type: 'setNotification', key: 'notification', value: 'failed to sign transaction.' });
      signTransactionRetryCount++;
      // await setTimeout(state.config.clientParameters.retry.signTransaction.retryWaitingTime);
      await sleep(state.config.clientParameters.retry.signTransaction.retryWaitingTime);
    }

    if (signTransactionRetryCount > state.config.clientParameters.retry.signTransaction.retryMax) {
      // -- retry over エラー終了
      devLog('sign transaction retry over.');
      dispatch({ type: 'setNotification', key: 'notification', value: 'failed to sign transaction.' });
      return result;
    }
  }

  // ブロードキャスト

  result = {};
  let broadcastTransactionRetryCount = 0;

  while (result.status !== 'fulfilled') {
    result = await broadcastTransaction({ clientParameters: state.config.clientParameters, signedTxHex: transactionSigned });
    devLog('broadcast transaction; result', JSON.stringify(result));

    if (result.status === 'fulfilled') {
      devLog('succeeded to broadcast transaction.');
      txid = result.body;
      dispatch({ type: 'setNotification', key: 'notification', value: 'succeeded to broadcast transaction. ' + txid });
    }
    else {
      devLog('failed to broadcast transaction.');
      dispatch({ type: 'setNotification', key: 'notification', value: 'failed to broadcast transaction.' });
      broadcastTransactionRetryCount++;
      // await setTimeout(state.config.clientParameters.retry.broadcastTransaction.retryWaitingTime);
      await sleep(state.config.clientParameters.retry.broadcastTransaction.retryWaitingTime);
    }

    if (broadcastTransactionRetryCount > state.config.clientParameters.retry.broadcastTransaction.retryMax) {
      // -- retry over エラー終了
      devLog('send transaction retry over.');
      dispatch({ type: 'setNotification', key: 'notification', value: 'failed to broadcast transaction.' });
      return result;
    }
  }

  return {
    status: 'fulfilled',
    body: txid,
  };
}

// 「ポイント合計:検索」ボタン押下 HANDLE CLICK GET POINT SUM
// eslint-disable-next-line no-unused-vars
async function handleClickGetPointSum(state, dispatch, activeCertification, consistentRead) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  if (activeCertification === undefined || activeCertification === null) {
    activeCertification = {
      address: null,
    };
  }

  if (consistentRead === undefined || consistentRead === null) {
    consistentRead = false;
  }

  // state固定
  const stateFixed = {
    // addressMain: state.getPointHistory.addressMain,
    // signatureVersion: state.configMP.clientParameters.signatureVersion.getPointSum,
    // addressCheck: 'strict',
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {

    // activeCertificationの場合は別処理
    if (address !== activeCertification.address) {

      // state固定
      stateFixed[address] = {
        // addressCoinType: state.session[address].addressCoinType,
        sessionId: state.session[address].sessionId,
        expirationOfSession: state.session[address].expirationOfSession,
      };

      if (stateFixed[address].expirationOfSession >= now + (state.marginOfSessionTime ?? 60000)) {
        certifications.push({
          // addressCoinType: stateFixed[address].addressCoinType,
          address: address,
          sessionId: stateFixed[address].sessionId,
          consistentRead: address === stateFixed.addressMain ? consistentRead : false,
        });
      }
    }
  }

  // activeCertificationの処理

  if (activeCertification.address !== null) {
    // -- state固定
    stateFixed[activeCertification.address] = {
      sessionId: activeCertification.sessionId,
      expirationOfSession: activeCertification.expirationOfSession,
    };

    // -- 有効だったら(まあほぼ有効なんだろうけど)プッシュ
    if (stateFixed[activeCertification.address].expirationOfSession >= now + (state.marginOfSessionTime ?? 60000)) {
      certifications.push({
        address: activeCertification.address,
        sessionId: stateFixed[activeCertification.address].sessionId,
        consistentRead: true, // activeCertificationは常に強力な整合性のある読み込みをする。
      });
    }
  }

  // アクティブなMONAアドレスが有り、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。
  const extendedCertificationProperties = [
    { key: 'consistentRead', value: consistentRead },
  ];

  await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });

  // 対象がなければ戻る。
  if (certifications.length === 0) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    body: {
      action: 'pointSum',
      certifications: certifications,
    },
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'pointSum', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain]?.certificatedBy === 'signature' || response.body[stateFixed.addressMain]?.certificatedBy === 'sessionId') {
      // // cookie情報更新(アドレス情報)
      // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      // const cookiesNew = [
      //       {
      //         action: 'searchPurchaseHistory',
      //         addressType: 'addressMain',
      //         description: `${userName}`,
      //         time: now,
      //         address: stateFixed.addressMain
      //       },
      // ];

      // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}
// 「クリエイター情報編集」ボタン押下 HANDLE CLICK EDIT CREATOR INFORMATION
async function handleClickEditCreatorInformation(state, dispatch, asset, { keyPairs } = {}) {
  let addressMainActual;
  let signature;
  let request = {};
  let messages = {};
  let result;
  let keyPair;

  // state固定
  const stateFixed = {
    creater: state.creatorInformation.creater,
    createrText: state.creatorInformation.createrText,
    monacottoAddressMain: state.creatorInformation.monacottoAddressMain,
    createrLink: state.creatorInformation.createrLink,
    signatureVersion: state.config.clientParameters.signatureVersion.editCreatorInformation,
  };

  // 必須項目チェック
  if (asset === undefined || asset === null || asset === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.assetMustBeFilled[state.language] });
    return;
  }

  const clientTime = Date.now();

  if (keyPairs !== undefined && keyPairs !== null) {
    let result;

    keyPair = keyPairs[0];
    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressMainActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return result;
    }

    // 署名
    const message = `I edit the creator information of ${asset}. My main address is ${addressMainActual}. I am the owner of the card. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else {
    result = await window.mpurse.getAddress()
    .then( (result) => {
      addressMainActual = result;

      return 'fulfilled';
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    const message = `I edit the creator information of ${asset}. My main address is ${addressMainActual}. I am the owner of the card. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    result = await window.mpurse.signMessage(message)
    .then( result => {
      signature = result;
      return 'fulfilled';
    })
    .catch( err => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }
  }

  const formData = new FormData();

  const requestJson = JSON.stringify({
    body: {
      addressMain: addressMainActual,
      addressMainActual: addressMainActual,
      asset: asset,
      creater: stateFixed.creater,
      createrText: stateFixed.createrText,
      monacottoAddressMain: stateFixed.monacottoAddressMain,
      createrLink: stateFixed.createrLink,
      clientTime : clientTime,
      signature : signature,
      signatureVersion : stateFixed.signatureVersion,
    }
  });

  formData.append('json', requestJson);

  request.body = formData;
  request.headers = {};
  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/edit_creator_information';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "out of service": words.outOfService[state.language],
    "signature by asset owner is required.": words.signatureByAssetOwnerIsRequired[state.language],
    "asset is required; not asset_longname.": words.assetIsRequiredNotAssetLongname[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', addressMainActual],
      value: {'sessionId': response.body.sessionId.addressMain, 'expirationOfSession': response.body.expirationOfSession.addressMain} });

    // -- 登録カード情報取得
    getRegisteredCard(state, dispatch);
  }
  else {
  }

  return response;
}

// UPLOAD IMAGE AND GET CID
async function uploadImageAndGetCid(state, dispatch, imageKeys) {
  let request = {};
  let cid;

  const image = imageKeys.reduce( (acc, cur) => acc?.[cur], state );

  const formData = new FormData();

  if (image !== undefined && image !== null) {
    formData.append('image', image);
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.noImage[state.language] });
    throw new Error('noImage');
  }

  request.body = formData;
  request.headers = {};
  request.url = 'https://card.mona.jp/api/upload_image';
  request.method = 'POST';

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest(request);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    devLog('response.body', response.body);
    cid = response.body.success.cid;
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToUploadTheImage[state.language] });
    throw new Error('failedToUploadTheImage');
  }

  return cid;
}

// リロード
// HANDLE CLICK RELOAD
async function handleClickReload(state, dispatch) {
  const now = new Date();

  for (const address of Object.keys(state.session)) {
    if (state.session[address].expirationOfSession >= now.getTime() + (state.marginOfSessionTime ?? 60000)) {

      // 保有アセット取得
      const monapartyPromise = getBalancesMonaparty({ dispatch, address, clientParameters: state.config.clientParameters })
      .then( (result) => {
        let assets;

        if (result.status === 'fulfilled') {
          const balance = result.body;
          assets = Object.keys(balance);
        }
        else {
          throw new Error(result.error);
        }

        // アセット情報取得
        return getAssetInfo({ dispatch, assets, assetInfos: state.assetInfo, clientParameters: state.config.clientParameters });
      })
      .then( (result) => {
        let assetInfo;

        if (result.status === 'fulfilled') {
          assetInfo = result.body;
        }
        else {
          throw new Error(result.error);
        }

        // モナカード情報取得
        const assetCommons = Object.keys(assetInfo)
        .filter( asset => {
          try {
            return JSON.parse(assetInfo[asset]?.description).monacard === undefined;
          }
          catch (error) {
            return true;
          }
        })
        .map( asset => assetInfo[asset].asset_longname === null ? asset : assetInfo[asset].asset_longname );

        getMonacard({ dispatch, assets: assetCommons, monacards: state.monacard });
      })
      .catch( (error) => {
        // stateFixed.addressMainだったら、エラー＆再ログインしてください通知。
      });

      // MONA残高取得

      const monaPromise = getAddressInfo({ clientParameters: state.config.clientParameters, address })
      .then( (result) => {
        if (result.status === 'fulfilled') {
          const balance = result.body.balance;
          dispatch({ type: 'setStateMultiLayers', keys: ['balance', 'mona', address], value: balance });
        }
        else {
          devLog('failed to get address info.');
          // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '3.5' });
        }
      });

      // オウンドアセット情報取得

      const ownedAssetsPromise = getOwnedAssets({ dispatch, address, clientParameters: state.config.clientParameters })
      .then( (result) => {
        if (result.status === 'fulfilled') {
        }
        else {
          devLog('failed to get owned asset.');
          // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[state.language] + '3.5' });
        }
      });


      dispatch({ type: 'setState', key: 'accessing', value: true });

      await Promise.all([monapartyPromise, monaPromise, ownedAssetsPromise]);

      dispatch({ type: 'setState', key: 'accessing', value: false });

      // let activeCertification;

      // if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
      //   if  (response.body[stateFixed.addressMain].certificatedBy === 'signature') {
      //     activeCertification = {
      //       address: stateFixed.addressMain,
      //       sessionId: response.body[stateFixed.addressMain].sessionId,
      //       expirationOfSession: response.body[stateFixed.addressMain].expirationOfSession,
      //     };
      //   }
      // }

      // const result = await handleClickGetPointSum(state, dispatch, activeCertification);
      // devLog('point sum', JSON.stringify(result.body));
    }
  }
}

export {
  quantityForDisplay,
  addSendsToTheCartMona,
  addTokensToTheCartMonaparty,
  buildMonaTransactions,
  handleClickCommitMonaTransaction,
  handleClickIssueAsset,
  handleClickEditAssetInfo,
  handleClickAdditionalIssuance,
  handleClickLockIssuance,
  handleClickTransferOwnership,
  fetchRecentTxids,
  handleClickEditCreatorInformation,
  firstTransactionRitual,
  handleClickReload,
  handleClickSwapMnemonics,
  sweepMona,
  sweepAssets,
};
